import React from 'react';

const FacebookIcon: React.FC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="16" cy="16" r="16" fill="#1877F2" />
    <path
      d="M20.5 21L21.25 16.5H17V13C17 11.6716 17.6716 10.5 19.5 10.5H21.5V6.5C21.5 6.5 19.7 6.25 18 6.25C14.5 6.25 12 8.46562 12 12.475V16.5H8V21H12V30.5C12.75 30.65 13.5 30.75 14.25 30.75C15 30.75 15.75 30.65 16.5 30.5V21H20.5Z"
      fill="white"
    />
  </svg>
);

export default FacebookIcon;
